import { ConfigInterface } from 'swr';
import { api, FetcherOptions, useApi } from '@gik/core/api';
import { InkindPageAPIModel } from '../../core/models/gik/InkindPage';

export async function getInkind(inkindRouteId: string): Promise<InkindPageAPIModel> {
  const response = await api.get(`inkinds/${inkindRouteId}`);

  if (!response.ok) {
    throw await response.json();
  }

  return (await response.json()) as InkindPageAPIModel;
}

export function useInkind(inkindRouteId?: string, config?: ConfigInterface, opts?: FetcherOptions) {
  return useApi<InkindPageAPIModel>(inkindRouteId ? `inkinds/${inkindRouteId}` : null, config, opts);
}
